import React from 'react';
import FlamencosIcon from '../../images/projectIcons/flamencos.webp';

const Flamencos = (props) => (
  <img src={FlamencosIcon} alt="flamencos-logo" {...props} />
);

export default Flamencos;
